import { RootState } from '../store';

export const selectCardActions = (state: RootState) => state.cardActions.cardActionsData;
export const selectCardActionsLoaded = (state: RootState) => state.cardActions.loaded;
export const selectCardActionsError = (state: RootState) => state.cardActions.error;
